<template>
	<div class="inline-box">
		<svg-icon icon-class="cj-icon-search" @click.stop="isShowSearch = !isShowSearch" style="cursor: pointer; font-size: 20px" />
		<section class="search-container" v-show="isShowSearch" @click.stop.self="isShowSearch = false;">
			<div>
				<div class="input-cls">
					<el-input v-model="searchText" @input="changeInput" ref="searchText" name="searchText" placeholder="搜索客户、工单 或 沟通" type="text">
						<svg-icon slot="suffix" icon-class="search" style="font-size: 22px; margin-right: 10px;" />
					</el-input>
				</div>
				<div class="cell-cls" v-show="searchText">
					<div @click.stop="handleView('/customer/index')" class="item"><svg-icon icon-class="customer" /> 包含 <big >{{searchText}}</big> 的客户</div>
					<div @click.stop="handleView('/customer/index')" class="item"><svg-icon icon-class="telc" /> 包含 <big>{{searchText}}</big> 的工单</div>
					<div @click.stop="handleView('/communicate/index')" class="item"><svg-icon icon-class="mai" /> 包含 <big>{{searchText}}</big> 的沟通</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
export default {
	name: 'SearchTip',
	data() {
		return {
			isShowSearch: false,
			keyAlt: '',
			keyS: '',
			searchText: '',
			restaurants: [],
		};
    },
	watch: {
		isShowSearch: {
			handler(val){
				this.keyCodes = '';
			},
			immediate:true
		}
	},
	created: function() {
		const self = this;
        document.onkeydown = function(e) {
			if(e.ctrlKey && e.keyCode === 70) {
				self.isShowSearch = !self.isShowSearch;
				e.preventDefault();
				setTimeout(() => {
					self.$refs.searchText.focus();
				}, 100);
			}
        };
    },
	methods: {
		handleView(path) {
			this.isShowSearch = false;
			if((this.$route?.query?.phone == this.searchText) && (this.$route?.path == path)) {
				this.searchText = '';
				return;
			}
			this.$router.push({path: path, query: {phone: this.searchText}});
			this.searchText = '';
		},
		changeInput(val) {
			this.searchText = val.replace(/(^\s*)|(\s*$)/g, "");
		}
	}
}
</script>

<style lang="scss" scoped>
big {
	color: #337EFF;
	font-size: 18px;
	
	font-weight: bold;
}
.inline-box{
	display: inline-block;
	padding: 0 8px;
	font-size: 24px;
	vertical-align: text-bottom;

	& > .search-container {
		width: 100%;
		height: 100vh;
		background: rgba(0,0,0,0);
		position: fixed;
		top: 0;
		left: 0;
		z-index: 2000;

		& > div {
			width: 50%;
			margin: 15% auto;
			background: #fff;
			border-radius: 4px;
			padding: 5px;
			box-sizing: border-box;
			box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.2);

			& > .input-cls {
				width: 100%;
				height: 50px;
				::v-deep .el-input, ::v-deep input {
					width: 100%;
					height: 50px;
					line-height: 50px;
					vertical-align: top;
					font-size: 16px;
				}
			}

			& > .cell-cls {
				width: 100%;
				padding: 5px 0;
				box-sizing: border-box;

				& > .item {
					width: 100%;
					height: 40px;
					line-height: 40px;
					font-size: 14px;
					color: rgb(51, 51, 51);
					cursor: pointer;
					padding: 0 15px;
					box-sizing: border-box;

					&:hover {
						background: #E5EEFF ;
					}
				}
			}
		}

		// & > .input-cls {
		// 	width: 50%;
		// 	height: 50px;
		// 	margin: 15% auto;

		// 	::v-deep .el-autocomplete, ::v-deep .el-input, ::v-deep input {
		// 		width: 100%;
		// 		height: 50px;
		// 		line-height: 50px;
		// 		vertical-align: top;
		// 		font-size: 16px;
		// 	}
		// }
	}
}
</style>
